import React from "react"
import Select from "react-select"
import { GetPrice } from "../../../../common/utils/property_utils"

const MinPrice = ({
  selectOptions,
  minPriceVal,
  maxPriceVal,
  searchTypeVal,
  handleChange,
  menuIsOpen,
}) => {
  const minPrice = [{ value: "", label: "Min Price" }]

  // console.log("minPrice", minPrice)

  selectOptions.forEach((item) => {
    const maxPrice = parseInt(maxPriceVal, 10)
    const itemPrice = parseInt(item.label, 10)
    if (maxPrice) {
      if (itemPrice < maxPrice) {
        minPrice.push({
          value: item.label,
          label:
            searchTypeVal === "lettings"
              ? `${GetPrice(itemPrice)} pcm`
              : GetPrice(itemPrice),
        })
      }
    } else {
      minPrice.push({
        value: item.label,
        label:
          searchTypeVal === "lettings"
            ? `${GetPrice(itemPrice)} pcm`
            : GetPrice(itemPrice),
      })
    }
  })

  return (
    <div className="select-option dropdown">
      <Select
        options={minPrice}
        placeholder="Min Price"
        className="react-select"
        classNamePrefix="react-select"
        onChange={(event) => handleChange(event.value)}
        value={minPrice.filter((item) => item.value === minPriceVal)}
        menuIsOpen={menuIsOpen}
      />
    </div>
  )
}
export default MinPrice
